import loadable from '@loadable/component';

const InstantSearchMobile = loadable(() =>
  import(/* webpackPrefetch: true */ './instant-search-mobile')
);

export default InstantSearchMobile;
